export const MAX_SCROLL_WIDTH = 420;
